import React from 'react';

const LoadingSpinner = () => (
	<div className="d-flex justify-content-center">
		<div className="spinner-border" role="status">
		</div>
	</div>
);

const ButtonLoaddingSpinner = () => (
	<button className="btn btn-lg btn-primary btn-block" type="submit" disabled>
		<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
		<span className="sr-only">Enviando...</span>
		Enviando...
  </button>
);

export {LoadingSpinner, ButtonLoaddingSpinner};
